import api from "../../config/apiConfig";

const dashboard = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/admin/dashboard", data, {
        headers: {
            Authorization: accessToken,
        },
    });
    return response.data;
}

const getRmDashboardData = async (data: any) => {
    const accessToken = localStorage.getItem("accessToken");
    const response = await api.post("/admin/rm/dashboard", data, {
        headers: {
            Authorization: accessToken,
        },
    });
    return response.data;
}

const dashboardService = { dashboard, getRmDashboardData };
export default dashboardService;